import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { TipoMovimientoFinanciero } from '@/@core/utils/enums/financiero'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosFinancieroPG, { RESOURCE_FINANCIERO_PG } from '@/auth/permissions/modules/financiero'
import { defineRoutes } from '@/utils/router'

const { configuracion, informes, mantenimiento, transacciones } = permisosFinancieroPG

export default defineRoutes([
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/financiero-pg/mantenimiento/bancos',
        name: namesMantenimiento.ROUTE_BANCOS,
        component: () => import('@pages/financiero-pg/mantenimiento/bancos/GestionBancos.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.bancos',
            resource: RESOURCE_FINANCIERO_PG,
            action: mantenimiento.bancos,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.mantenimiento',
                'financiero-pg.subopciones.bancos'
            ),
        },
    },
    {
        path: '/financiero-pg/mantenimiento/cuentas-bancarias',
        name: namesMantenimiento.ROUTE_CUENTA_BANCARIAS,
        component: () => import('@pages/financiero-pg/mantenimiento/cuentas-bancarias/GestionCuentasBancarias.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.cuentas',
            resource: RESOURCE_FINANCIERO_PG,
            action: mantenimiento.cuentasBancarias,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.mantenimiento',
                'financiero-pg.subopciones.cuentas'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACIÓN
     */
    {
        path: '/financiero-pg/configuracion/nivel-aprobacion-flujo-pago',
        name: namesConfiguracion.ROUTE_NIVEL_APROBACION_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/configuracion/NivelesAprobacion.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.nivel_aprobacion',
            resource: RESOURCE_FINANCIERO_PG,
            action: configuracion.nivelAprobacionFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.configuracion',
                'financiero-pg.subopciones.nivel_aprobacion'
            ),
        },
    },
    {
        path: '/financiero-pg/configuracion/permiso-cuenta-bancaria',
        name: namesConfiguracion.ROUTE_PERMISO_CUENTA_BANCARIA,
        component: () => import('@pages/financiero-pg/configuracion/PermisoCuentaBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.permiso_cuenta_bancaria',
            resource: RESOURCE_FINANCIERO_PG,
            action: configuracion.permisoCuentaBancaria,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.configuracion',
                'financiero-pg.subopciones.permiso_cuenta_bancaria'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/financiero-pg/transacciones/transferencia',
        name: namesTransacciones.ROUTE_CREAR_TRANSFERENCIA,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.enums.tipo_movimiento.transferencia',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearTransferencia,
            tipoTransaccion: TipoMovimientoFinanciero.TRANSFERENCIA,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias',
                'financiero-pg.enums.tipo_movimiento.transferencia'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/nota-debito',
        name: namesTransacciones.ROUTE_CREAR_NOTA_DEBITO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.enums.tipo_movimiento.transferencia',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearNotaDebito,
            tipoTransaccion: TipoMovimientoFinanciero.TRANSFERENCIA,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias',
                'financiero-pg.enums.tipo_movimiento.nota_debito'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/cheque',
        name: namesTransacciones.ROUTE_CREAR_CHEQUE,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.enums.tipo_movimiento.cheque',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearCheque,
            tipoTransaccion: TipoMovimientoFinanciero.CHEQUE,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias',
                'financiero-pg.enums.tipo_movimiento.cheque'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/deposito',
        name: namesTransacciones.ROUTE_CREAR_DEPOSITO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.enums.tipo_movimiento.deposito',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearDeposito,
            tipoTransaccion: TipoMovimientoFinanciero.DEPOSITO,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias',
                'financiero-pg.enums.tipo_movimiento.deposito'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/nota-credito',
        name: namesTransacciones.ROUTE_CREAR_NOTA_CREDITO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.enums.tipo_movimiento.nota_credito',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearNotaCredito,
            tipoTransaccion: TipoMovimientoFinanciero.NOTA_CREDITO,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias',
                'financiero-pg.enums.tipo_movimiento.nota_credito'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/bandeja-transaccion-bancaria',
        name: namesTransacciones.ROUTE_BANDEJA_TRANSACCIONES_BANCARIAS,
        component: () => import('@pages/financiero-pg/transacciones/bandeja/BandejaTransaccionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.transacciones_bancarias_bandeja',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.bandejaTransaccionesBancarias,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.transacciones_bancarias_bandeja'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/crear-flujo-pago/:num_flujo?',
        name: namesTransacciones.ROUTE_CREAR_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/CrearFlujoPago.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.flujo_pago',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.crearFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.flujo_pago'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/bandeja-flujo-pago',
        name: namesTransacciones.ROUTE_BANDEJA_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/BandejaFlujoPago.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.flujo_pago_bandeja',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.bandejaFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.flujo_pago_bandeja'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/revision-flujos-pago',
        name: namesTransacciones.ROUTE_BANDEJA_REVISION_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/BandejaRevisionFlujoPago.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.revision_flujos_pago',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.revisionFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.revision_flujos_pago'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/revision-flujo-pago/:num_flujo',
        name: namesTransacciones.ROUTE_REVISION_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/RevisionFlujoPago.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.revision_flujo_pago',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.revisionFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.revision_flujo_pago'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/aprobacion-flujo-pago',
        name: namesTransacciones.ROUTE_APROBACION_FLUJO_PAGO,
        component: () => import('@pages/financiero-pg/transacciones/crear-transaccion/AprobacionFlujoPago.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.aprobacion_flujo_pago',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.aprobacionFlujoPago,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.aprobacion_flujo_pago'
            ),
        },
    },
    {
        path: '/financiero-pg/transacciones/conciliacion-bancaria',
        name: namesTransacciones.ROUTE_CONCILIACION_BANCARIA,
        component: () => import('@pages/financiero-pg/transacciones/ConciliacionBancaria.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.conciliacion_bancaria',
            resource: RESOURCE_FINANCIERO_PG,
            action: transacciones.conciliacionBancaria,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.transacciones',
                'financiero-pg.subopciones.conciliacion_bancaria'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/financiero-pg/informes/reporte-status',
        name: namesInformes.ROUTE_REPORTE_STATUS,
        component: () => import('@pages/financiero-pg/informes/ReporteStatus.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.reporte_status',
            resource: RESOURCE_FINANCIERO_PG,
            action: informes.reporteStatus,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.informes',
                'financiero-pg.subopciones.reporte_status'
            ),
        },
    },
    {
        path: '/financiero-pg/informes/archivo-bancos',
        name: namesInformes.ROUTE_ARCHIVO_BANCOS,
        component: () => import('@pages/financiero-pg/informes/ArchivoBancos.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.archivo_bancos',
            resource: RESOURCE_FINANCIERO_PG,
            action: informes.archivoBancos,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.informes',
                'financiero-pg.subopciones.archivo_bancos'
            ),
        },
    },
    {
        path: '/financiero-pg/informes/libro-bancos',
        name: namesInformes.ROUTE_LIBRO_BANCOS,
        component: () => import('@pages/financiero-pg/informes/LibroBancos.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.libro_bancos',
            resource: RESOURCE_FINANCIERO_PG,
            action: informes.libroBancos,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.informes',
                'financiero-pg.subopciones.libro_bancos'
            ),
        },
    },
    {
        path: '/financiero-pg/informes/movimientos-bancarios',
        name: namesInformes.ROUTE_MOVIMIENTOS_BANCARIOS,
        component: () => import('@pages/financiero-pg/informes/MovimientosBancarios.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.movimientos_bancarios',
            resource: RESOURCE_FINANCIERO_PG,
            action: informes.movimientosBancarios,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.informes',
                'financiero-pg.subopciones.movimientos_bancarios'
            ),
        },
    },
    {
        path: '/financiero-pg/informes/reporte-pagos',
        name: namesInformes.ROUTE_REPORTE_PAGOS,
        component: () => import('@pages/financiero-pg/informes/ReportePagos.vue'),
        meta: {
            title: 'i18n:financiero-pg.subopciones.reporte_pagos',
            resource: RESOURCE_FINANCIERO_PG,
            action: informes.reportePagos,
            breadcrumb: buildBreadcrumb(
                'a:financiero-pg.menu_title',
                'a:global.menu.informes',
                'financiero-pg.subopciones.reporte_pagos'
            ),
        },
    },
])
